// components/Survey/SurveyPortalShell.jsx — stripped-down layout for staff who only have survey access
import React from "react";
import { useMsal } from "@azure/msal-react";
import { NavLink, Outlet } from "react-router-dom";
import { Avatar, Badge, Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger, Text } from "@fluentui/react-components";
import { SignOut24Regular, Person24Regular, ArrowLeft20Regular } from "@fluentui/react-icons";
import { useSurveys } from "../../context/SurveyContext";
import { useUserAccess } from "../../context/UserAccessContext";

export default function SurveyPortalShell() {
  const { instance, accounts } = useMsal();
  const user = accounts[0] || null;
  const { myPendingCount } = useSurveys();
  const { hasAppAccess } = useUserAccess();

  return (
    <div style={{ minHeight: "100vh", background: "#F3F2F1", display: "flex", flexDirection: "column" }}>
      <header style={{ height: 60, background: "linear-gradient(90deg,#001A3D 0%,#002D7A 100%)", display: "flex", alignItems: "center", padding: "0 24px", gap: 16, position: "sticky", top: 0, zIndex: 50, boxShadow: "0 2px 10px rgba(0,0,0,0.18)" }}>
        <NavLink to="/my-surveys" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <div style={{ width: 34, height: 34, borderRadius: 8, background: "linear-gradient(135deg,#0066FF,#00C4CC)", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 13, color: "#fff" }}>LO</div>
          <div>
            <Text style={{ color: "#fff", fontWeight: 700, fontSize: 14, display: "block", lineHeight: 1.2 }}>LekOil</Text>
            <Text style={{ color: "rgba(255,255,255,0.6)", fontSize: 11 }}>Staff Surveys</Text>
          </div>
        </NavLink>
        <div style={{ flex: 1 }} />
        {hasAppAccess && (
          <NavLink to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "rgba(255,255,255,0.8)", fontSize: 13, textDecoration: "none" }}>
            <ArrowLeft20Regular style={{ fontSize: 16 }} /> Back to dashboard
          </NavLink>
        )}
        {myPendingCount > 0 && (
          <Badge appearance="filled" color="warning" style={{ fontSize: 11 }}>{myPendingCount} to complete</Badge>
        )}
        <Menu>
          <MenuTrigger>
            <MenuButton appearance="transparent" icon={<Avatar name={user?.name || "User"} size={28} color="brand" />} style={{ color: "#fff" }}>
              <span style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: 13 }}>{user?.name || "Signed in"}</span>
            </MenuButton>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem icon={<Person24Regular />} disabled>{user?.username || ""}</MenuItem>
              <MenuItem icon={<SignOut24Regular />} onClick={() => instance.logoutPopup({ postLogoutRedirectUri: "/" })}>Sign out</MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </header>
      <main style={{ flex: 1, padding: "28px 20px 48px" }}>
        <Outlet />
      </main>
      {!hasAppAccess && (
        <footer style={{ textAlign: "center", fontSize: 11, color: "#8A8886", padding: "0 0 20px" }}>
          You have survey-only access. Contact the SCM administrator if you need access to the dashboard.
        </footer>
      )}
    </div>
  );
}
